<template xmlns:v-slot="http://www.w3.org/1999/xhtml">
  <div :style="'backgroundImage: url('+getBgImage +')'" class="home manual-wrap active">
    <turn :data="manuals" :height="manualHeight" :width="manualWidth" @change="handleTurnChange"
          @next="handleNext"
          @prev="handleTurnPrev"
          @tap="handleToggleControl"
          @turning="handleTurning"
          ref="turn">
      <template v-slot:pictemp="pict">
        <div class="w-full flex a-end absolute bottom-0 left-0 text-white text-left">
          <div class="flex-1">
            <div class="w-full text-white text-left p-h-10"
                 style="z-index:2000;background: #00000040">
              <span class="w-full lh-30 bold fs-14">{{pict.item.title}}</span>
            </div>
            <div class="w-full text-white text-left p-h-10 max-h-60"
                 style="z-index:2000;background: #00000040">
              <span class="w-full lh-20" style="word-break: break-all">{{pict.item.desc}}</span>
            </div>
          </div>
          <div class="w-120 flex a-center j-center"
               v-if="pict.item.buttonInfo.desc">
            <div :style="{backgroundImage:getButtomColor(pict.item.buttonInfo.bgColor)}" @click.stop="onJumpClick"
                 @mousedown.stop
                 @mousemove.stop
                 @mouseup.stop
                 class="w-80 b-radius-16 h-30 lh-30 text-center color-white text-nowrap o-hidden m-v-10"
                 style="z-index:2000;pointer-events: auto">
              {{pict.item.buttonInfo.desc||''}}
            </div>
          </div>
        </div>
      </template>
    </turn>
  </div>
</template>

<script>
import turn from '../../../components/ebookprew'

export default {
  name: 'Ebookprew',
  components: {
    turn
  },
  data () {
    return {
      manualWidth: 1000,
      manualHeight: 800,
      manuals: [],
      listener: null,
      position: 0,
      bgUrl: ''
    }
  },
  computed: {
    getBgImage () {
      if (!this.bgUrl) {
        return require('../../../assets/common/img_book_bg.jpg')
      } else {
        return this.bgUrl
      }
    }
  },
  mounted () {
    window.onresize = () => {
      this.manualWidth = window.innerWidth - 300
      this.manualHeight = window.innerHeight - 60
    }
    this.init()
  },
  destroyed () {
    if (this.listener) {
      window.removeEventListener('message', this.listener, false)
      this.listener = null
    }
  },
  methods: {
    init () {
      let that = this
      this.listener = function (messageEvent) {
        let data = messageEvent.data
        if (data.type === 'change') {
          if (data.width) {
            that.manualWidth = data.width
          }
          if (data.height) {
            that.manualHeight = data.height
          }
          if (data.picList && data.picList.length) {
            that.manuals = data.picList.filter(res => {
              return res.picurl
            }).map(res => {
              res.picture_image = res.picurl
              return res
            })
            that.bgUrl = data.bgUrl
            //zgh::: 避免白板
            that.handleSwitchManual(0)
          } else {
            that.manuals = []
          }
        } else if (data.type === 'setPosition') {
          that.handleSwitchManual(data.index)
        } else if (data.type === 'Forward') {
          that.handleForward()
        } else if (data.type === 'Backward') {
          that.handleBackward()
        }
      }
      window.addEventListener('message', this.listener, false)
      let data = {
        type: 'status',
        time: new Date(),
        result: 'OK'
      }
      window.parent.postMessage(data, '*')
    },

    handleSwitchManual (index) {
      this.$refs['turn'].toPage(index)
    },
    handleForward () {
      if (this.position + 1 < this.manuals.length) {
        this.$refs['turn'].toPage(this.position + 1)
      }
    },
    handleBackward () {
      if (this.position - 1 > -1) {
        this.$refs['turn'].toPage(this.position - 1)
      }
    },
    getButtomColor (colorValue) {
      return 'linear-gradient(to right,' + colorValue + ',#00000000 )'
    },
    handleTurnChange (e) {
      this.position = e
      console.log('handleTurnChange===>', e)
    },
    handleToggleControl (e) {
      console.log('handleToggleControl===>', e)
    },
    handleTurning (e) {
      console.log('handleTurning===>', e)
    },
    handleTurnPrev (e) {
      console.log('handleTurnPrev===>', e)
    },
    handleNext (e) {
      console.log('handleNext===>', e)
    },
    onJumpClick (e) {
      console.log('onJumpClick===>', e)
    }
  }
}
</script>

<style lang="scss" scoped>
  .manual-wrap {
    overflow: hidden;
    position: relative;
    z-index: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    //zgh 右侧手机模型内不显示问题
    //justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transform: scale(0.95);
    transform: scale(0.95);
    -webkit-transition: opacity ease 0.5s;
    transition: opacity ease 0.5s;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
    /*background-color: aliceblue;*/
    background-repeat: no-repeat;
    background-size: cover;
  }

  .manual-wrap.active {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
</style>
